import React from 'react'
import Svg from 'assets/email.svg'
import ContactButton from './ContactButton'

export default () => (
  <ContactButton href="mailto:yana@tsaryk.com" svgId={Svg.id!} text="yana@tsaryk.com" />
)
